import {KontStammEpic} from 'module/KontStamm/KontStammEpic'
import {Module} from 'module/Module'
import {KontStammReducerNS} from 'module/KontStamm/KontStammReducer'

/**
 * throw kontStammFetchAction() when requesting new data
 */

export const KontStammModule: Module = {
	reducerNS: KontStammReducerNS,
	epics: [KontStammEpic],
}